import { useState } from "react";

// components
import ChartContainer from "components/molecules/ChartContainer";
import { ChartErrorState } from "components/molecules/ErrorStates";
import AnnualEmissionSavingsByMeasureTable from "components/organisms/Charts/Recommendations/AnnualEmissionSavingsByMeasureTable";

// query hooks
import { useCumulativeEmissionSavingsCard } from "queries/Reports/Recommendations/useCumulativeEmissionSavingsCard";
import { useAnnualEmissionSavingsByMeasureTable } from "queries/Reports/Recommendations/useAnnualEmissionSavingsByMeasureTable";
import { useAnnualEmissionSavingsByMeasureChart } from "queries/Reports/Recommendations/useAnnualEmissionSavingsByMeasureChart";
import AnnualEmissionSavingsByMeasureChart from "components/organisms/Charts/Recommendations/AnnualEmissionSavingsByMeasureChart";

// styling
import CumulativeEmissionSavingsCard from "components/organisms/Charts/Recommendations/CumulativeEmissionSavingsCard";
import { ChartNoDataState } from "components/molecules/NoDataState";

interface AnnualEmissionSavingsByMeasuresProps {
    backgroundColor?: string;
    filtersetUid: string;
}

function AnnualEmissionSavingsByMeasures({ backgroundColor, filtersetUid }: AnnualEmissionSavingsByMeasuresProps) {
    const [showChart, setShowChart] = useState(true);
    const {
        isLoading: chartIsLoading,
        error: chartError,
        data: chartData,
    } = useAnnualEmissionSavingsByMeasureChart(filtersetUid);
    const {
        isLoading: tableIsLoading,
        error: tableError,
        data: tableData,
    } = useAnnualEmissionSavingsByMeasureTable(filtersetUid);

    if (chartError || tableError) return <ChartErrorState />;
    if (chartData === null || tableData === null)
        return <ChartNoDataState title="Recommended Decarbonization Measure Types" />;

    return (
        <ChartContainer
            title="Recommended decarbonization measure types"
            loading={chartIsLoading || tableIsLoading}
            onClickTable={() => setShowChart((show) => !show)}
            exportableData={tableData}
        >
            {showChart ? (
                <>
                    <AnnualEmissionSavingsByMeasureChart
                        query={() => useAnnualEmissionSavingsByMeasureChart(filtersetUid)}
                        backgroundColor={backgroundColor}
                    />
                    <CumulativeEmissionSavingsCard query={() => useCumulativeEmissionSavingsCard(filtersetUid)} />
                </>
            ) : (
                <AnnualEmissionSavingsByMeasureTable
                    query={() => useAnnualEmissionSavingsByMeasureTable(filtersetUid)}
                />
            )}
        </ChartContainer>
    );
}

export default AnnualEmissionSavingsByMeasures;
